import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App.jsx";
import { GameProvider } from "@/contexts/GameContext";
import { SettingsProvider } from "@/contexts/SettingsContext";

createRoot(document.getElementById("root")).render(
  <SettingsProvider>
    <GameProvider>
      <App />
    </GameProvider>
  </SettingsProvider>
);
